import { render, staticRenderFns } from "./LineComment.vue?vue&type=template&id=a0c8ec56&scoped=true"
import script from "./LineComment.vue?vue&type=script&lang=js"
export * from "./LineComment.vue?vue&type=script&lang=js"
import style0 from "./LineComment.vue?vue&type=style&index=0&id=a0c8ec56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c8ec56",
  null
  
)

export default component.exports